export default __webpack_public_path__ + "static/media/img-3.67851c34.jpg";